import React from 'react';
export function Footer() {
  return <footer className="bg-[#0F4C5C] border-t-4 border-[#A7B7C1] py-10 px-4 text-center" data-id="element-137" data-mp="32wd2qgad7ltj">
      <p className="text-xs text-white/60 max-w-3xl mx-auto mb-4 leading-relaxed" data-id="element-138" data-mp="3ggtymjf7hl5r">
        Educational teaching-support material for dental instructors, clinical faculty, dental educators and dental
        assisting and hygiene program instructors. It does not replace an accredited dental curriculum, professional
        licensing requirements, current clinical guidelines, local regulations or qualified clinical supervision, and it
        is not medical advice for patients. Results depend on each instructor, student and training context; no
        specific results are guaranteed.
      </p>
      <p className="text-sm text-white/80" data-id="element-139" data-mp="3qbvmzd1nqj7a">© Dental Instructor Atlas 2026 — All Rights Reserved.</p>
    </footer>;
}